import axios from 'axios'
import { API_URL } from '../../../../../../constants'
import { DISPUTE_API, DISPUTE_REASON_LOOKUP_API } from './consts'
import { CulpritCandidate, CulpritPreview, DisputeRecord, DisputeReasonLookupItem } from './response.types'
import {
  ChangeDisputeReasonRequest,
  CreateDisputeRequest,
  CreatePayoutDisputeRequest,
  ResolveDisputeRejectRequest,
  ResolveDisputeSuccessRequest,
  ResolvePayoutDisputeSuccessRequest,
} from './requests.types'
import { DisputeQuery } from './query.types'

export interface ApiResponse<T> {
  success: boolean
  data: T | null
  totalRows?: number
  errors?: Record<string, string>
  // Машиночитаемый код доменной ошибки (CPAYMENT-1591) — на нём строятся тексты в модалках.
  errorCode?: string
}

export const getDisputeReasonLookup = () =>
  axios.get<ApiResponse<DisputeReasonLookupItem[]>>(`${API_URL}${DISPUTE_REASON_LOOKUP_API}`)

// Тип спора — в пути там, где у типов разный вход: создание и успех.
export const createDepositDispute = (body: CreateDisputeRequest) =>
  axios.post<ApiResponse<DisputeRecord>>(`${API_URL}${DISPUTE_API}/deposit`, body)

export const createPayoutDispute = (body: CreatePayoutDisputeRequest) =>
  axios.post<ApiResponse<DisputeRecord>>(`${API_URL}${DISPUTE_API}/payout`, body)

export const getCulpritCandidates = (payoutToken: string) =>
  axios.get<ApiResponse<CulpritCandidate[]>>(`${API_URL}${DISPUTE_API}/payout/${payoutToken}/culprit-candidates`)

export const getDisputeList = (params: DisputeQuery) =>
  axios.get<ApiResponse<DisputeRecord[]>>(`${API_URL}${DISPUTE_API}/list`, { params })

export const resolveDepositDisputeSuccess = (id: number, body: ResolveDisputeSuccessRequest) =>
  axios.post<ApiResponse<DisputeRecord>>(`${API_URL}${DISPUTE_API}/deposit/${id}/resolve-success`, body)

export const resolvePayoutDisputeSuccess = (id: number, body: ResolvePayoutDisputeSuccessRequest) =>
  axios.post<ApiResponse<DisputeRecord>>(`${API_URL}${DISPUTE_API}/payout/${id}/resolve-success`, body)

export const previewPayoutDisputeSuccess = (id: number, body: ResolvePayoutDisputeSuccessRequest) =>
  axios.post<ApiResponse<CulpritPreview[]>>(`${API_URL}${DISPUTE_API}/payout/${id}/resolve-success/preview`, body)

export const resolveDisputeReject = (id: number, body: ResolveDisputeRejectRequest = {}) =>
  axios.post<ApiResponse<DisputeRecord>>(`${API_URL}${DISPUTE_API}/${id}/resolve-reject`, body)

export const changeDisputeReason = (id: number, body: ChangeDisputeReasonRequest) =>
  axios.patch<ApiResponse<DisputeRecord>>(`${API_URL}${DISPUTE_API}/${id}/reason`, body)
